export const watchPhoneScreen = window.matchMedia("only screen and (max-width: 499px)");
export const watchSmallScreen = window.matchMedia("only screen and (max-width: 1024px)");
export const watchMediumScreen = window.matchMedia("only screen and (min-width: 1024px) and (max-width: 1450px)");
export const watchMediumAndSmallerScreen = window.matchMedia("only screen and (max-width: 1450px)");
